import * as React from 'react'
import { IconsModel } from './iconsModel'

function SvgApartment(
	{
		color,
		width = 96,
		height = 96
	}: IconsModel
) {
	return (
		<svg width={width} height={height} viewBox="0 0 96 96">
			<path
				fill={color}
				fillRule="evenodd"
				d="M81.404 32.12v51.468l11.753 5.245-1.263 2.828-12.039-5.373-12.039 5.373-1.262-2.828 11.753-5.245V32.12h3.097zM57.93 50.24c6.122 0 11.103 4.98 11.103 11.103 0 1.397-.257 2.76-.763 4.052l-.048.108L58.06 86.53h-5.324v5.03H49.64v-5.03H20.138v5.03H17.04v-5.03h-5.886L.943 65.395a11.052 11.052 0 01-.763-4.051c0-6.122 4.981-11.103 11.103-11.103s11.103 4.98 11.103 11.103v2.666h24.442v-2.666c0-6.122 4.981-11.103 11.103-11.103zm0 3.097c-4.414 0-8.006 3.592-8.006 8.006v5.763H19.29v-5.763c0-4.414-3.591-8.006-8.006-8.006-4.414 0-8.006 3.592-8.006 8.006 0 .99.178 1.954.529 2.868l9.291 19.222h43.02l9.291-19.222a7.97 7.97 0 00.53-2.868c0-4.414-3.593-8.006-8.007-8.006zM50.624 30.57c5.192 0 9.416 4.224 9.416 9.417v7.148h-3.096v-7.148a6.327 6.327 0 00-6.32-6.32H19.15a6.328 6.328 0 00-6.32 6.32v7.148H9.735v-7.148c0-5.193 4.224-9.417 9.416-9.417zM84.176 5.9l11.691 22.986H63.842L75.533 5.901h8.644zm-1.9 3.097h-4.844L68.89 25.79h21.93L82.278 8.998z"
			/>
		</svg>
	)
}

export default SvgApartment
